import { Component } from '@angular/core';

@Component({
  selector: 'app-navigation-com',
  templateUrl: './navigation.com.html'
})

export class NavigationComponent {

  showFullScreenMenu = false;
  brand = '虾丸云商';

  public openFullScreenMenu() {
    this.showFullScreenMenu = !this.showFullScreenMenu;
  }

  public handleEvent(e) {
    if (e.source === 'full-screen-menu') {
      if (e.action === 'close') {
        this.showFullScreenMenu = false;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/com/navigation/navigation.com.ts